import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "name": "Gatsby Link"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "gatsby-link"
    }}>{`Gatsby Link`}</h1>
    <p>{`Add an active style to `}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/linking-between-pages/"
      }}>{`Gatsby Link`}</a>{` or other React router link components.
Import the Theme UI `}<a parentName="p" {...{
        "href": "/guides/jsx-pragma"
      }}>{`custom JSX pragma`}</a>{` for styling
the router link components directly, without using wrapper components.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Link
  to="/recipes/gatsby-link/"
  activeClassName="active"
  sx={{
    color: 'inherit',
    '&.active': {
      color: 'primary',
    },
  }}>
  Link
</Link>
`}</code></pre>
    <p>{`Full code for this example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`/** @jsxImportSource theme-ui */
import { Link } from 'gatsby'

export default (props) => (
  <Link
    {...props}
    activeClassName="active"
    sx={{
      color: 'inherit',
      '&.active': {
        color: 'primary',
      },
    }}
  />
)
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      